import matchPath from './matchPath';
export default matchPath;
